import React, { Suspense, lazy } from 'react';
import { useTranslation } from '../i18n';

const CesiumGlobeWithPins = lazy(() => import('./CesiumGlobeWithPins'));

const GlobeWithPins = (props) => {
  const { t } = useTranslation();
  const heightClass = props.heightClass || 'h-[560px] md:h-[700px]';

  return (
    <Suspense
      fallback={(
        <div
          className={`w-full ${heightClass} grid place-items-center rounded-2xl text-white`}
          style={{
            background: 'radial-gradient(circle at 45% 35%, rgba(250,204,21,0.14), rgba(1,6,18,0.98) 62%)',
            border: '1px solid rgba(250,204,21,0.18)',
          }}
        >
          <div className="rounded-full border border-yellow-300/30 bg-black/50 px-4 py-2 text-sm font-bold text-yellow-100">
            {t('globe.loading')}
          </div>
        </div>
      )}
    >
      <CesiumGlobeWithPins {...props} />
    </Suspense>
  );
};

export default GlobeWithPins;
